
export const HPSidebarRules = {
    standard: {
        showSearch: true,
        showDashboard: true,
        showToDoList: true,
        showPipeline: true,
        showProductLookup: true,
        showResources: true,
        showCertification: true,
        showAccounts: true,
    },
    PACEParticipant: { // Advertiser
        showSearch: true,
        showDashboard: true,
        showToDoList: true,
        showPipeline: true,
        showProductLookup: true,
        showResources: true,
        showCertification: false, // GALA-2219
        showAccounts: true,
    },
    suspendedCompliance: {
        showSearch: true,
        showDashboard: true,
        showToDoList: false,
        showPipeline: true,
        showProductLookup: false,
        showResources: false,
        showCertification: false,
        showAccounts: true,
    },
    benjiView: {
        showSearch: false,
        showDashboard: true,
        showToDoList: false,
        showPipeline: false,
        showProductLookup: false,
        showResources: false,
        showCertification: false, // originally true
        showAccounts: true,
    },
};



// WEBPACK FOOTER //
// ./src/app/config/app.sidebarRules.config.js